import { defineMessages } from 'react-intl';

export const resourcesMessages = defineMessages({
    'resources.title': {
        id: 'resources.title',
        defaultMessage: 'Resources',
        description: 'Title for the resources page',
    },
    'resources.description': {
        id: 'resources.dialog.description',
        defaultMessage:
            '{sponsor} provided resources to help you manage your health and well-being.',
        description: 'Description for the resources dialog',
    },
    'resources.disclaimer': {
        id: 'resources.dialog.disclaimer',
        defaultMessage:
            'The services on this page are provided by third parties, not Calm, and are options made available by your employer. Calm is not responsible for, and does not endorse or recommend, any of these services.',
        description: 'Description for the resources dialog',
    },
    'resources.learn_more': {
        id: 'resources.learn_more',
        defaultMessage: 'Learn More',
        description: 'Learn more button text',
    },
    'resources.promo.title': {
        id: 'resources.promo.title',
        defaultMessage: 'View Resources From {sponsor}',
        description: 'Title for the promo banner',
    },
    'resources.promo.subtitle': {
        id: 'resources.promo.subtitle',
        defaultMessage:
            'Services that help you manage your health and well-being.',
        description: 'Subtitle for the promo banner',
    },
    'resources.promo.button': {
        id: 'resources.promo.button',
        defaultMessage: 'View Resources',
        description: 'Button text for the promo banner',
    },
    'resources.benefit_assistance.title': {
        id: 'resources.benefit_assistance.title',
        defaultMessage: 'Have Questions?',
        description: 'Title for the benefit assistance banner',
    },
    'resources.benefit_assistance.subtitle.phone': {
        id: 'resources.benefit_assistance.subtitle.phone',
        defaultMessage: 'Call: {phoneNumber}',
        description:
            'Subtitle for the benefit assistance banner when phone number is provided',
    },
    'resources.benefit_assistance.subtitle.email': {
        id: 'resources.benefit_assistance.subtitle.email',
        defaultMessage: 'Email: {email}',
        description:
            'Subtitle for the benefit assistance banner when email is provided',
    },
    'resources.benefit_assistance.subtitle.contact': {
        id: 'resources.benefit_assistance.subtitle.contact',
        defaultMessage: 'Contact Us',
        description:
            'Subtitle for the benefit assistance banner when url is provided',
    },
    'resources.carousel.title': {
        id: 'resources.carousel.title',
        defaultMessage: 'Resources',
        description: 'Title for the resources carousel',
    },
    'resources.carousel.smart.title': {
        id: 'resources.carousel.smart.title',
        defaultMessage: 'Related Resources',
        description: 'Title for the smart resources carousel',
    },
    'resources.carousel.subtitle': {
        id: 'resources.carousel.subtitle',
        defaultMessage: '{number} helpful {service} from {sponsor}',
        description: 'Subtitle for the resources carousel',
    },
    'resources.carousel.smart.subtitle': {
        id: 'resources.carousel.smart.subtitle',
        defaultMessage: 'Helpful {service} from {sponsor}',
        description: 'Subtitle for the resources carousel',
    },
    'resources.tab.for_you': {
        id: 'resources.tab.for_you',
        defaultMessage: 'For You',
        description: 'Label for the "For You" tab in resources',
    },
    'resources.tab.all_resources': {
        id: 'resources.tab.all',
        defaultMessage: 'All Resources',
        description: 'Label for the "All" tab in resources',
    },
    'resources.for_you.description': {
        id: 'resources.for_you.description',
        defaultMessage:
            'These resources have been selected based on the information you’ve shared with Calm Health.',
        description: 'Description for the "For You" tab in resources',
    },
    'resources.carousel.title.aria_label': {
        id: 'resources.carousel.title.aria_label',
        defaultMessage: 'Resources carousel',
        description: 'Aria label for the resources carousel title',
    },
    'resources.carousel.view_all.aria_label': {
        id: 'resources.carousel.view_all.aria_label',
        defaultMessage: 'View all resources',
        description: 'Aria label for the "View All" button in resources',
    },
    'resources.carousel.card.aria_label': {
        id: 'resources.carousel.card.aria_label',
        defaultMessage: 'Resource: {resourceName}',
        description: 'Aria label for the resource card in the carousel',
    },
    'resources.action_sheet.description': {
        id: 'resources.action_sheet.description',
        defaultMessage: 'Provided by {sponsor}',
        description: 'Description for the action sheet in resources',
    },
    'resources.carousel.label.service': {
        id: 'resources.carousel.label.service',
        defaultMessage: 'service',
        description: 'Label for a single service in the resources carousel',
    },
    'resources.carousel.label.services': {
        id: 'resources.carousel.label.services',
        defaultMessage: 'services',
        description: 'Label for multiple services in the resources carousel',
    },
});

export default resourcesMessages;
